import { render, staticRenderFns } from "./PractitionerAnnualReturnApplications.vue?vue&type=template&id=dde85bfa&scoped=true&"
import script from "./PractitionerAnnualReturnApplications.vue?vue&type=script&lang=js&"
export * from "./PractitionerAnnualReturnApplications.vue?vue&type=script&lang=js&"
import style0 from "./PractitionerAnnualReturnApplications.vue?vue&type=style&index=0&id=dde85bfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde85bfa",
  null
  
)

export default component.exports